import { StyleSheet } from 'react-native';
import { neutrals, stroke } from 'src/theme/colors';

export const style = StyleSheet.create({
  checkbox: {
    width: 24,
    height: 24,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: stroke.strokeColorActive,
    backgroundColor: neutrals.white,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkboxActive: {
    borderRadius: 4.8,
    borderWidth: 1.2,
    borderColor: neutrals.white,
    backgroundColor: stroke.strokeColorActive,
  },
  iconCheck: {
    width: 13,
    height: 13,
  },
});
